export const currencyTypes = [
    { type: "INR", taxType: ["CGST", "SGST"] },
    { type: "GBP", taxType: ["VAT"] },
    { type: "AED", taxType: ["VAT"] },
    { type: "LAK", taxType: ["VAT"] }
]
